import React from 'react';
import { Head } from '@inertiajs/react';
import TagForm from '@/components/admin/blog/TagForm';

interface Tag {
  id: number;
  name: string;
  slug: string;
}

interface Props {
  tag: Tag;
}

const Edit: React.FC<Props> = ({ tag }) => {
  return (
    <>
      <Head title={`Edit: ${tag.name}`} />
      <TagForm tag={tag} isEditing={true} />
    </>
  );
};

export default Edit;
